import type { IconSvgObject } from './types';

const UserDollarIcon: IconSvgObject = [
  ["path", { d: "M15 7C15 4.23858 12.7614 2 10 2C7.23858 2 5 4.23858 5 7C5 9.76142 7.23858 12 10 12C12.7614 12 15 9.76142 15 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 14.5H16.5C15.6716 14.5 15 15.1716 15 16C15 16.8284 15.6716 17.5 16.5 17.5H19.5C20.3284 17.5 21 18.1716 21 19C21 19.8284 20.3284 20.5 19.5 20.5H15M18 13V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 19C3 15.134 6.13401 12 10 12C11.0736 12 12.0907 12.2417 13 12.6736", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserDollarIcon;
